// Arranque de la interfaz.
import './parts/index.js';
import { App } from './app.js';
import { CodeEditor } from './ui/editor.js';
import { setupPanels } from './ui/panels.js';
import { Inspector } from './ui/inspector.js';
import { setupAnalyzer } from './ui/analyzer.js';
import { setupTerminals } from './ui/terminals.js';
import { setupModal, openCatalog, openExamples, openProjects, openLibraries, openHelp, openWokwiImport, confirmDiscard } from './ui/dialogs.js';
import { setupAccount } from './ui/account.js';
import { setupModes, startTask } from './ui/modes.js';
import { setupPlan, openShare } from './ui/plan.js';
import { fetchUser, loginUrl } from './session.js';
import { DEFAULT_EXAMPLE, EXAMPLES } from './examples/index.js';

const app = new App();
window.__app = app; // útil para depurar desde la consola
app.init(document.getElementById('stage'));
const editor = new CodeEditor(app, document.getElementById('editor'), document.getElementById('file-tabs'));
setupPanels(app, editor);
new Inspector(app, document.getElementById('inspector'));
setupAnalyzer(app);
setupTerminals(app);
setupModal(app);
setupAccount(app);
setupModes(app);
setupPlan(app);

document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-action]');
  if (!b) return;
  document.querySelectorAll('.menu.open').forEach((m) => m.classList.remove('open'));
  switch (b.dataset.action) {
    case 'catalog':
      return app.blocked() || openCatalog(app);
    case 'examples':
      return openExamples(app);
    case 'libraries':
      return openLibraries(app);
    case 'help':
      return openHelp();
    case 'open':
      return openProjects(app);
    case 'new':
      if (confirmDiscard(app)) app.newProject();
      return;
    case 'save':
      return app.saveNow();
    case 'save-as':
      return app.saveNow({ copy: true });
    case 'link':
      return openShare(app);
    case 'export':
      return app.exportJson();
    case 'import':
      return document.getElementById('file-input').click();
    case 'wokwi':
      return openWokwiImport(app);
  }
});

document.getElementById('file-input').addEventListener('change', async (e) => {
  const f = e.target.files[0];
  e.target.value = '';
  if (!f || !confirmDiscard(app)) return;
  app.importJson(await f.text());
});

function readDraft() {
  try {
    return JSON.parse(localStorage.getItem('arduino3d.draft') || 'null');
  } catch {
    return null;
  }
}

async function start() {
  // Sesión: sin cuenta se usa el simulador igual, con el borrador local.
  try {
    app.setUser(await fetchUser());
  } catch (e) {
    app.setUser(null);
    app.toast('No se pudo revisar tu sesión: ' + e.message, true);
  }
  // Con contraseña temporal, primero se cambia (en el portal) y se vuelve aquí.
  if (app.user && app.user.mustChange) {
    app.leaving = true;
    location.replace(loginUrl(location.pathname + location.search));
    return;
  }
  const path = location.pathname;
  let t;
  if ((t = /^\/tareas\/([a-z0-9]+)\/(trabajo|plantilla)\/?$/.exec(path))) return startTask(app, t[2] === 'trabajo' ? 'work' : 'template', t[1]);
  if ((t = /^\/entregas\/([a-z0-9]+)\/?$/.exec(path))) return startTask(app, 'review', t[1]);

  const draft = readDraft();
  const m = /^\/p\/([a-z0-9]+)/.exec(path);
  if (m && (await app.openProject(m[1], { link: true }))) {
    // Si quedó un borrador más nuevo (p. ej. se recargó antes de guardar), se recupera.
    if (app.kind === 'project' && draft && draft.id === m[1] && app.lastLoadedAt && draft.at > app.lastLoadedAt + 1000) {
      app.load(draft.project, { id: m[1], keepView: true });
      app.markDirty();
    }
    return;
  }
  // /?ejemplo=<id>: lo usan los ejemplos que se abren desde una tarea (en otra pestaña).
  const ejemplo = new URLSearchParams(location.search).get('ejemplo');
  if (ejemplo && EXAMPLES.some((x) => x.id === ejemplo)) {
    app.openExample(ejemplo);
    return;
  }
  if (draft && !draft.id && draft.project && Date.now() - draft.at < 7 * 864e5 && path === '/') {
    app.load(draft.project, { id: null });
    app.hasUserChanges = true;
    app.dirty = true;
    app.emit('save-state');
    return;
  }
  let last = null;
  try {
    last = localStorage.getItem('arduino3d.last');
  } catch {
    // sin almacenamiento local
  }
  // El último proyecto propio (si se abre uno ajeno, no se queda como «último»).
  if (last && app.user && (await app.openProject(last)) && app.kind === 'project') return;
  app.openExample(DEFAULT_EXAMPLE);
}

start().then(() => {
  // La primera vez se muestra la ayuda (no dentro de una tarea: ahí van las instrucciones; ni encima de otro aviso,
  // como el de un enlace que no se pudo abrir).
  try {
    if (!localStorage.getItem('arduino3d.seenHelp') && app.kind === 'project' && document.getElementById('modal').hidden) {
      localStorage.setItem('arduino3d.seenHelp', '1');
      if (!navigator.webdriver) openHelp();
    }
  } catch {
    // sin almacenamiento local
  }
});

// Recarga en vivo en dev (no en navegadores automatizados: las capturas de prueba no deben recargarse).
if (process.env.NODE_ENV === 'development' && !navigator.webdriver) {
  const es = new EventSource('/__reload');
  es.onmessage = (e) => {
    const d = JSON.parse(e.data);
    if (d.errors && d.errors.length) console.error('Error al compilar el frontend:\n' + d.errors.join('\n'));
    else if (!d.hello) location.reload();
  };
}
